import { TranslateService } from '@ngx-translate/core';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CountryModel } from 'src/app/shared/models/country.model';
import { OperationMode } from 'src/app/shared/models/enum.model';
import { MunicipalityModel } from './../../shared/models/municipality.model';
import { FilterCountries } from './../../shared/ngxs/action/country.action';
import {
  AddMunicipality,
  EditMunicipality,
} from './../../shared/ngxs/action/municipality.action';
import { CountryState } from './../../shared/ngxs/state/country.state';

@Component({
  selector: 'app-manage-municipality',
  templateUrl: './manage-municipality.component.html',
  styleUrls: ['./manage-municipality.component.scss'],
})
export class ManageMunicipalityComponent implements OnInit {
  model = new MunicipalityModel();
  title = 'Add';
  opModes = OperationMode;
  opMode = OperationMode.Create;
  confirmationBtnText = '';
  cancelBtnText = 'Cancel';

  subscription = new Subscription();

  @Select(CountryState.countries)
  counties$: Observable<CountryModel[]>;

  countryControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  group: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    if (data) {
      if (data.model) {
        this.model = data.model;
      }
      this.opMode = data.mode;

      this.confirmationBtnText =
        this.opMode === OperationMode.Create ? 'Create' : 'Update';
      this.title = this.opMode === OperationMode.Create ? 'Add' : 'Edit';
    }

    this.group = this.formBuilder.group({
      id: [this.model.id],
      name: [this.model.name, Validators.required],
      city: [this.model.city, Validators.required],
    });
  }

  ngOnInit(): void {
    this.store.dispatch(new FilterCountries());

    this.filteredOptions = this.countryControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );

    this.subscribeEvents();
  }

  subscribeEvents() {
    this.subscription.add(
      this.counties$.subscribe((x) => {
        if (x) {
          this.options = x.map((x) => x.name);
        }
      })
    );
  }

  onConfirm() {
    const dbModel = new MunicipalityModel();
    dbModel.id = this.group.controls['id'].value;
    dbModel.name = this.group.controls['name'].value;
    dbModel.language = this.translateService.currentLang;
    dbModel.city = this.group.controls['city'].value;

    if (this.opMode === OperationMode.Create) {
      this.store.dispatch(new AddMunicipality(dbModel));
    } else if (this.opMode === OperationMode.Edit) {
      this.store.dispatch(new EditMunicipality(dbModel));
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(
      (option) => option.toLowerCase().indexOf(filterValue) === 0
    );
  }
}
